export {
  default,
  loader,
} from "~/components/search/SearchTitleAndResult";

export const eager = true;
export const sync = true;
export const cache = "listing";
